<template>
  <div
    :class="
      'bg-gradient-to-br ' + classColor + ' rounded-lg border ' + 
      classColor.replace('from-', 'border-') + 
      ' ' + getDarkModeClasses() + ' p-5 hover:shadow-md transition-all'
    "
  >
    <div class="flex items-center justify-between">
      <div>
        <p class="text-sm mb-1 font-medium" :class="getTextColor()">{{ labelTitle }}</p>
        <div class="space-y-1">
          <p class="text-lg font-bold" :class="getValueColor()">{{ labelTxt }}</p>
        </div>
      </div>
      <div class="w-12 h-12 rounded-lg flex items-center justify-center shadow-lg" :class="getIconBgColor()">
        <i class="fa-solid fa-chart-bar text-white text-lg"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  labelTxt: {
    type: [String],
    default: "0",
  },
  labelTitle: {
    type: [String],
    default: "کۆی داهات",
  },
  classColor: {
    type: [String],
    default: "from-blue-50 to-blue-100",
  },
});

// Get text color based on classColor - improved contrast for dark mode
const getTextColor = () => {
  if (props.classColor.includes('blue')) return 'text-blue-700 dark:text-gray-200';
  if (props.classColor.includes('green')) return 'text-green-700 dark:text-gray-200';
  if (props.classColor.includes('red')) return 'text-red-700 dark:text-gray-200';
  if (props.classColor.includes('yellow')) return 'text-yellow-700 dark:text-gray-200';
  if (props.classColor.includes('purple')) return 'text-purple-700 dark:text-gray-200';
  return 'text-gray-700 dark:text-gray-200';
};

// Get value color based on classColor - improved contrast for dark mode
const getValueColor = () => {
  if (props.classColor.includes('blue')) return 'text-blue-900 dark:text-gray-100';
  if (props.classColor.includes('green')) return 'text-green-900 dark:text-gray-100';
  if (props.classColor.includes('red')) return 'text-red-900 dark:text-gray-100';
  if (props.classColor.includes('yellow')) return 'text-yellow-900 dark:text-gray-100';
  if (props.classColor.includes('purple')) return 'text-purple-900 dark:text-gray-100';
  return 'text-gray-900 dark:text-gray-100';
};

// Get dark mode classes based on classColor - exact same as ItemList.vue and Home.vue
const getDarkModeClasses = () => {
  if (props.classColor.includes('blue')) return 'dark:from-blue-900/20 dark:to-blue-800/20 dark:border-blue-800';
  if (props.classColor.includes('green')) return 'dark:from-green-900/20 dark:to-green-800/20 dark:border-green-800';
  if (props.classColor.includes('red')) return 'dark:from-red-900/20 dark:to-red-800/20 dark:border-red-800';
  if (props.classColor.includes('yellow')) return 'dark:from-yellow-900/20 dark:to-yellow-800/20 dark:border-yellow-800';
  if (props.classColor.includes('purple')) return 'dark:from-purple-900/20 dark:to-purple-800/20 dark:border-purple-800';
  return 'dark:from-gray-900/20 dark:to-gray-800/20 dark:border-gray-800';
};

// Get icon background color based on classColor
const getIconBgColor = () => {
  if (props.classColor.includes('blue')) return 'bg-blue-500 dark:bg-blue-600';
  if (props.classColor.includes('green')) return 'bg-green-500 dark:bg-green-600';
  if (props.classColor.includes('red')) return 'bg-red-500 dark:bg-red-600';
  if (props.classColor.includes('yellow')) return 'bg-yellow-500 dark:bg-yellow-600';
  if (props.classColor.includes('purple')) return 'bg-purple-500 dark:bg-purple-600';
  return 'bg-gray-500 dark:bg-gray-600';
};
</script>
